module.exports = __webpack_public_path__ + "static/img/shetou@3x.0357e1c.png";


//////////////////
// WEBPACK FOOTER
// ./static/icons/shetou@3x.png
// module id = 5CiM
// module chunks = 1